/**
 * Dashboard Page
 * Main dashboard view after authentication
 * 
 * Requirements: 6.1, 7.1
 */

import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-[#17386E]">
              Bienvenue, {user?.full_name || user?.first_name}!
            </h1>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
            >
              Déconnexion
            </button>
          </div>
          
          <div className="space-y-4">
            <div className="border-l-4 border-[#4CE0C2] pl-4">
              <p className="text-gray-600">Email: {user?.email}</p>
              <p className="text-gray-600">Téléphone: {user?.phone || 'Non renseigné'}</p>
              <p className="text-gray-600">Rôle: {user?.roles?.[0] || 'N/A'}</p>
              <p className="text-gray-600">
                2FA: {user?.two_factor_enabled ? 'Activé' : 'Désactivé'}
              </p>
            </div>
            
            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-600">
                Votre session est active et persistera même après avoir fermé le navigateur.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
